// extracted by mini-css-extract-plugin
export default {"restButtonsGroup":"styles_restButtonsGroup__Jdfru","restButton":"styles_restButton__gZK7x"};